import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  paymentLink: "",
  renewalInfo: {},
  ckycStatus: false,
  proposalDetails: {},
  nomineeDetails: {},
  masterDetails: {},
  validationForm: {
    valid: true,
    errors: [],
    editMode: false,
  },
  websiteToken: "",
};

export const proposalSlice = createSlice({
  name: "proposal",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setPaymentLink: (state, action) => {
      state.paymentLink = action.payload;
    },
    setRenewalInfo: (state, action) => {
      state.renewalInfo = action.payload;
    },
    setCkycStatus: (state, action) => {
      state.ckycStatus = action.payload;
    },
    setProposalDetails: (state, action) => {
      state.proposalDetails = action.payload;
    },
    setNomineDetails: (state, action) => {
      state.nomineeDetails = action.payload;
    },
    setMasterDetails: (state, action) => {
      state.masterDetails = action.payload;
    },
    setProposalResponse: (state, action) => {
      state.proposalResponse = action.payload;
    },
    setValidationForm: (state, action) => {
      state.validationForm = action.payload;
    },
    setWebsiteToken: (state, action) => {
      state.websiteToken = action.payload;
    },
    clearProposalData: () => {
      return initialState;
    },
  },
});

export const {
  setPaymentLink,
  clearProposalData,
  setRenewalInfo,
  setCkycStatus,
  setProposalDetails,
  setNomineDetails,
  setMasterDetails,
  setProposalResponse,
  setValidationForm,
  setWebsiteToken,
} = proposalSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const getPaymentLink = (state) => state.proposal.paymentLink;
export const getRenewalInfo = (state) => state.proposal.renewalInfo;
export const getCKYCStatus = (state) => state.proposal.ckycStatus;
export const getProposalDetails = (state) => state.proposal.proposalDetails;
export const getMasterDetails = (state) => state.proposal.masterDetails;
export const getNomineDetails = (state) => state.proposal?.nomineeDetails;
export const getProposalResponse = (state) => state.proposal?.proposalResponse;
export const getValidationForm = (state) => state.proposal?.validationForm;
export const getWebsiteToken = (state) => state.proposal?.websiteToken;

export default proposalSlice.reducer;
